export type CommitError = {
  title: string
  _testKey: string
} & (
  | {
      type:
        | 'isRequired'
        | 'minLength'
        | 'maxLength'
        | 'regexPattern'
        | 'allowedMimeTypes'
        | 'allowedComponents'
        | 'allowedLanguages'
        | 'acceptedValues'
        | 'maxSize'
        | 'minValue'
        | 'maxValue'
        | 'minRows'
        | 'maxRows'
        | 'multipleValues'
        | 'acceptedReferenceTypes'
        | 'hiddenReferenceTarget'
        | 'acceptedUnionTypes'
        | 'multipleDefaultVariants'
        | 'missingDefaultVariant'
        | 'allowedMaxReferences'
        | 'allowedMinReferences'
      blockId: string
      overrideKey?: string
    }
  | {
      /**
       * For example, a component is deleted and the instance counterpart isn't staged for commit.
       */
      type: 'unresolvedComponent'
      blockId: string
      unresolvedComponentId: string
      overrideKey?: string
    }
  | {
      /**
       * For example, a component child is deleted and the instance counterpart isn't staged for commit.
       */
      type: 'unresolvedInstanceChildTarget'
      instanceBlockId: string
      targetBlockId: string
      overrideKey?: string
    }
  | {
      type: 'allowedNodes'
      blockId: string
      unallowedNodesFound: string[]
      overrideKey?: string
    }
  | { type: 'unknown'; blockId?: string; overrideKey?: string }
  | {
      type: 'illegalVariantValue'
      variantId: string
      blockId: string
      invalidKey: string
      overrideKey?: string
    }
)

export class CustomErrorCommit extends Error {
  errors: CommitError[]
  isCommitError = true

  constructor(errors: CommitError[]) {
    super('Commit failed')
    this.errors = errors
  }

  toJSON() {
    return {
      isCommitError: true,
      message: this.message,
      errors: this.errors,
    }
  }

  static fromJSON(json: unknown) {
    if (typeof json !== 'object' || json === null) {
      return null
    }
    if (
      'isCommitError' in json &&
      json.isCommitError === true &&
      'errors' in json &&
      Array.isArray(json.errors)
    ) {
      return new CustomErrorCommit(json.errors as CommitError[])
    }
    return null
  }
}
